import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '92%',
      display: 'flex',
      paddingTop: '1.5rem',
      position: 'relative',
      left: '6vw',
      [theme.breakpoints.down(1080)]: {
        width: '100%',
        display: 'grid',
        left: 'initial',
      },
    },
    subTtitle: {
      fontSize: '0.875rem',
      marginLeft: '0.25rem',
      [theme.breakpoints.down(1080)]: {
        fontSize: '1rem',
      },
    },
    checkbox: {
      padding: 0,
      '& *': {
        padding: 0,
      },
      '&.Mui-checked': {
        color: '#0094FF !important',
      },
      '&.MuiCheckbox-root': {
        color: '#E1E8ED',
      },
      '& svg': {
        fontSize: '1.2rem',
      },
    },
    filterContainer: {
      padding: '0.875rem',
      borderRadius: '1.25rem',
      background: '#fff',
      boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.10)',
      height: '22rem',
      maxWidth: '12rem',
      width: '25%',
      [theme.breakpoints.down(1080)]: {
        padding: '0.25rem',
        width: '90%',
        display: 'flex',
        maxWidth: '90%',
        height: '10rem',
        justifyContent: 'space-around',
        marginBottom: '1rem',
        justifySelf: 'center',
      },
    },
    tripsContainer: {
      width: '75%',
      [theme.breakpoints.down(1080)]: {
        width: '90%',
        justifySelf: 'center',
      },
    },
    days: {
      display: 'flex',
      alignItems: 'center',
      height: '2.5rem',
      width: '100%',
      marginLeft: '1rem',
      borderRadius: '1rem',
      padding: '0.5rem 1.125rem',
      background: '#fff',
      boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.10)',
      justifyContent: 'space-around',
      [theme.breakpoints.down(1080)]: {
        marginLeft: '0px',
        maxWidth: '94vw',
        '& button': {
          minWidth: 0,
        },
      },
    },
    dayContorl: {
      padding: '0.25rem 0.5rem',
      textTransform: 'none',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      borderRadius: '1.25rem',
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
    daySelected: {
      backgroundColor: '#0094FF',
      color: '#ffffff',
      '&:hover': {
        backgroundColor: '#0094FF',
        filter: 'brightness(0.9)',
      },
    },
    responsiveText: {
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
    },
    travelContainer: {
      width: '100%',
      position: 'relative',
      paddingTop: '1.5rem',
      marginLeft: '1rem',
      [theme.breakpoints.down(1080)]: {
        marginTop: '2rem',
        left: 'initial',
        width: '100%',
        marginLeft: '0',
        justifySelf: 'center',
      },
    },
    contentTravel: {
      width: '100%',
      padding: '1rem',
      marginTop: '1rem',
      borderRadius: '1.25rem',
      background: '#FFF',
      boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.10)',
      '& button p': {
        color: '#fff',
      },
    },
    subTitle: {
      fontSize: '0.9rem',
      [theme.breakpoints.down(1080)]: {
        fontSize: '1rem',
      },
    },
    contentTravelDisabled: {
      color: '#A3BBCC',
      '& svg path': {
        fill: '#A3BBCC',
      },
    },
    customMenuItem: {
      '& div': {
        fontWeight: 600,
        display: 'flex',
        alignItems: 'center',
        height: '1.5rem',
        padding: 0,
        marginLeft: '0.25rem',
        '& div': {
          paddingRight: '0 !importante',
        },
      },
      '& svg': {
        position: 'relative',
        right: '1rem',
      },
      '& fieldset': {
        border: 'none',
      },
    },
    selecetTravel: {
      backgroundColor: '#0094FF',
      borderRadius: '0.75rem',
      textTransform: 'none',
      '&:hover': {
        backgroundColor: '#0094FF',
        filter: 'brightness(0.9)',
      },
      '&:disabled': {
        backgroundColor: '#F5F8FA',
        '& svg path, p': {
          color: '#A3BBCC',
          fill: '#A3BBCC',
        },
      },
    },
    seatType: {
      display: 'flex',
      alignItems: 'center',
      '&:hover': {
        '& p': {
          fontWeight: 500,
        },
        '& svg path': {
          fill: '#0094FF',
        },
      },
    },
    horizontalBusPlan: {
      display: 'flex',
      marginRight: '1rem',
      position: 'relative',
      width: '100%',
      justifyContent: 'center',
      '& img': {
        width: '100%',
        minWidth: '45rem',
        [theme.breakpoints.down(780)]: {
          minWidth: '26rem',
          maxHeight: '58rem',
        },
      },
    },
    seat: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minWidth: '2rem',
      width: '2rem',
      height: '2rem',
      margin: '0.5rem',
      borderRadius: '6px',
      color: '#000',
      fontWeight: 600,
      border: '2px solid #000',
      '&:hover': {
        filter: 'brightness(0.9)',
      },
    },
    notAvaliable: {
      border: '1px solid #E22020',
      color: '#E22020',
    },
    selected: {
      backgroundColor: '#0094FF',
      border: '1px solid #0094FF',
      color: '#fff',
      '&:hover': {
        backgroundColor: '#0094FF',
        filter: 'brightness(0.9)',
      },
    },
    xl: {
      width: '3rem',
      height: '3rem',
    },
    md: {
      margin: '0.25rem',
    },
    busPlanContent: {
      display: 'block',
      position: 'absolute',
      right: '0.5rem',
    },

    firstBusPlanContentSm: {
      bottom: '8rem',
      display: 'flex',
      position: 'absolute',
      marginLeft: '8rem',
      top: 'initial',
      right: 'initial',
    },
    firstBusPlanContentXl: {
      top: '2.5rem',
      right: '1.5rem',
    },
    secondBusPlanContentSm: {
      bottom: '8rem',
      display: 'flex',
      position: 'absolute',
      marginRight: '8rem',
      right: 'initial',
    },
    secondBusPlanContentXl: {
      bottom: '3rem',
      right: '1.5rem',
    },
  }),
);

export default useStyles;
